export default state => state.i18n.strings;
